"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingWizardFlowTypes = void 0;
var BookingWizardFlowTypes;
(function (BookingWizardFlowTypes) {
    BookingWizardFlowTypes["Lesson"] = "lesson";
    BookingWizardFlowTypes["Simulator"] = "simulator";
    BookingWizardFlowTypes["Bowling"] = "bowling";
    BookingWizardFlowTypes["FirstLesson"] = "firstLesson";
    BookingWizardFlowTypes["ClubFitting"] = "clubFitting";
})(BookingWizardFlowTypes = exports.BookingWizardFlowTypes || (exports.BookingWizardFlowTypes = {}));
//# sourceMappingURL=AppointmentTypes.js.map